import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setCompany } from "../../redux/companySlice";
import { TextBox } from "devextreme-react";
import Modal from "react-modal";
import { RadioGroup, List } from 'devextreme-react';
import { UserCompanyService } from "../../apis/apiServices/userCompany";
import secureLocalStorage from "react-secure-storage";
import { Loader } from "./PageLoader";
import { setUser } from "../../redux/userSlice";

export default function ChangeCompanyComponent() {
    const dispatch = useDispatch();        
    const user = useSelector((state) => state.user?.data);
    const userCompany = useSelector((state) => state.company.data);
    
    const [isLoading, setIsLoading] = useState(false);
    const [companyList, setCompanyList] = useState([]);

    const fetchUserWiseCompanies = async () => {
        let response = await UserCompanyService?.getUserWiseAssignedCompanies(user?.userId);
        setCompanyList((response?.isSuccess) ? response?.data || [] : []);        
    }

    const closeModal = () => {
        dispatch(
            setCompany({
                id: userCompany?.id || 1,
                isChangeCompanyModalOpen: false,
            })
        );
    }

    useEffect(() => {
        fetchUserWiseCompanies();
    }, []);

    return (
        <>
            <Modal
                ariaHideApp={false}
                isOpen={userCompany?.isChangeCompanyModalOpen}
                className="react-modal custom-modal-small"
                onRequestClose={closeModal}
                shouldCloseOnOverlayClick={false}
                contentLabel="State Modal"
            >
                <form>
                    <div className="modal-header">
                        <h6 className="modal-title">Switch Company</h6>
                    </div>

                    <div className="modal-body">
                        <div className='form-group'>
                            <label>Company <span className="text-danger">*</span></label>
                            <List
                                dataSource={companyList || []}
                                keyExpr="id"
                                selectionMode="single" // multiple 
                                showSelectionControls={true}
                                selectedItemKeys={[userCompany?.id]}
                                onSelectionChanged={(e) => {
                                    let selectedItem = e?.component?.option("selectedItem");
                                    const companyPayload = {
                                        ...selectedItem,
                                        isChangeCompanyModalOpen: !userCompany?.isChangeCompanyModalOpen,
                                    }
                                    var userPayload = {...user, ...companyPayload};
                                    secureLocalStorage.setItem("company", companyPayload);
                                    secureLocalStorage.setItem("user", userPayload);
                                    dispatch(
                                        setCompany(companyPayload)
                                    );
                                    dispatch(
                                        setUser(userPayload)
                                    );

                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 1);
                                }}
                                itemRender={(comp) => (
                                    <div>{comp?.companyName}</div>
                                )}
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-outline-primary btn-sm"
                            onClick={closeModal}
                            title="Cancel"
                        >
                            <i className="fas fa-times"></i> Cancel
                        </button>

                    </div>


                </form>
            </Modal>
            {isLoading && <Loader loadingMessage={""} />}
        </>
    );
}